import { AuthenticatedHttpService } from 'http/httpService'
import { CursorPaginatedResponse } from '../../types'
import { AuditLogEntry, AuditLogQuery } from './schema'

export class AuditLogService {
    constructor(private httpService: AuthenticatedHttpService, private backofficeEndpoint: string) {}

    async listEntries(
        accountSlug: string,
        query: AuditLogQuery,
        signal?: AbortSignal,
    ): Promise<CursorPaginatedResponse<AuditLogEntry[]>> {
        const params = new URLSearchParams()
        Object.entries({
            from: query.from,
            to: query.to,
            object_id: query.objectId,
            cursor: query.cursor,
            page_size: query.pageSize,
        }).forEach(([key, value]) => {
            if (value) params.set(key, String(value))
        })
        Object.entries({
            object_type: query.objectType,
            actor: query.actor,
            source: query.source,
        }).forEach(([key, values]) => values?.forEach((value) => params.append(key, value)))
        const response = await this.httpService.fetch(
            `${this.backofficeEndpoint}api/v1/accounts/${accountSlug}/audit_log/?${params}`,
            { signal },
        )
        if (!response.ok) {
            throw new Error(`Activity log request failed: ${response.status}`)
        }
        return response.json()
    }

    async listActors(accountSlug: string, signal?: AbortSignal): Promise<string[]> {
        const response = await this.httpService.fetch(
            `${this.backofficeEndpoint}api/v1/accounts/${accountSlug}/audit_log/actors/`,
            { signal },
        )
        if (!response.ok) {
            throw new Error(`Activity log actors request failed: ${response.status}`)
        }
        const body = await response.json()
        return body.actors ?? []
    }
}
